import React from "react";
import { I18n } from 'react-redux-i18n';

import { getItem } from "../Tree";
import { FoldersProps } from "./folders.types";

export const useController = (props: FoldersProps) => {
  const selectedFolderName = React.useMemo(() => getItem(props.selectedFolderId, props.list).name, [props.selectedFolderId, props.list]);

  const labels = React.useMemo(() => ({
    deleteItem: `${I18n.t('Are you sure that you would like to delete the folder named')} ${selectedFolderName}? ${I18n.t('Deleting this folder will delete all of the pedigrees and individuals in this folder as well as any sub-folders and items they contain')}`
}), [selectedFolderName]);

  return { selectedFolderName, labels };
};
